import GenericStar from "@casino/external/icons/GenericStar";
import useFavouriteGame from "@casino/legacy/client/components/Game/GameView/shared/hooks/useFavouriteGame";
import { cn } from "@workspace/frontend-ui";
import type { MouseEvent } from "react";
import FavouriteToggleContainer from "./FavouriteToggleContainer";

type Props = {
  handleClick?: (event: MouseEvent<HTMLDivElement>) => void;
  game: GameFragment;
  className?: string;
};

const FavouriteToggle: FC<Props> = ({ game, className }) => {
  const { isFavourite, handleClick } = useFavouriteGame(game);
  return (
    <FavouriteToggleContainer handleClick={handleClick} className={className}>
      <GenericStar
        className={cn(
          "text-white text-xl/8 fill-transparent flex-shrink-0",
          isFavourite ? "fill-caution" : "fill-black",
        )}
      />
    </FavouriteToggleContainer>
  );
};

export default FavouriteToggle;
